export const isMobilizeVehicle = (sourcePartner: string | null | undefined): boolean =>
	sourcePartner?.toLowerCase() === 'mobilize';
